import React from 'react';
import { Card, CardActions, CardContent, Button, Typography, Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import "./SideBarCard.scss";
import IconHolder from '../../Common/IconHolder';
import SimplifiedIcon from '../../../icons/Simplified.svg';

export default function SideBarCard(props) {
    const { name, text } = props;

    return (
        <Card className="d-flex flex-column" variant="elevation">
            <CardContent className='pb-0'>
                <div className="d-flex">
                    <IconHolder icon={SimplifiedIcon} viewBox="0 0 24 24" />
                </div>
                <Typography variant="body1" component="div" className="mt-2">
                    <Box fontWeight="fontWeightBold" fontSize={14}>
                        {name}
                    </Box>
                    <Box fontSize={14} className='mt-2'>{text}</Box>
                </Typography>
            </CardContent>
            <CardActions className="d-block mt-auto pb-0">
                <div className="d-flex">
                    <Link to="#" className="sidebar-link">
                        <Button color="primary" className='sidebar-btn-padding' variant="text">LEARN MORE</Button>
                    </Link>
                </div>
            </CardActions>
        </Card>
    )
};

SideBarCard.propTypes = {
    name: PropTypes.string,
    text: PropTypes.string,
}


// WEBPACK FOOTER //
// ./src/components/Common/SideBarCard/SideBarCard.js